// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__NceYz","dragIcon":"Choice_dragIcon__3AxsG","left":"Choice_left___qANf","input":"Choice_input__2Yw78"};